<script setup lang="ts">
import moment from 'moment';
import { ref, onMounted } from 'vue';
import AuditsRepository from '../../repositories/audits.repository';
import { useI18n } from 'vue-i18n'
import DataTable from '@components/DataTable.vue';

const isLoadingAudits = ref<boolean>(false);
const isDownloadingExcel = ref<boolean>(false);

const { t } = useI18n();
const auditsRepository = new AuditsRepository();
const auditsData = ref([]);
const paginationData = ref();
const currentPage = ref<number>();

const getAuditsAPI = async (page: number) => {
  isLoadingAudits.value = true;
  try {
    const { data } = await auditsRepository.getAudits({
      page,
    });
    auditsData.value = data.audits ?? [];
    paginationData.value = data.pagination;
  } finally {
    isLoadingAudits.value = false;
  }
};

onMounted(async () => {
  getAuditsAPI(1);
});

const fieldsTable: any = ref([
  {
    key: 'id',
    label: t('global.id'),
    sortable: true,
  },
  {
    key: 'asset',
    label: t('seguimiento_web.tipo_mercancia'),
  },
  {
    key: 'email',
    label: t('global.email'),
  },
  {
    key: 'phone',
    label: t('global.telefono'),
  },
  {
    key: 'createdAt',
    label: t('global.fechayhora'),
    formatter: (e: any) => moment(e).format('DD-MM-YYYY HH:mm'),
  },
]);
const onChangePage = async (page: any) => {
  getAuditsAPI(page);
  currentPage.value = page;
};

const downloadExcel = async () => {
  if (isDownloadingExcel.value) return;
  isDownloadingExcel.value = true;
  try {
    await auditsRepository.getAuditsExcel();
  } finally {
    isDownloadingExcel.value = false;
  }
};
</script>

<template>
  <Layout :title="t('seguimiento_web.seguimiento_web')" :textColor="'color-secondary'">
    <template #layout>
      <CButton
        class="background-blue button__form position-relative"
        style="padding: 0.55rem !important"
        type="button"
        :disabled="isDownloadingExcel"
        :class="{ disabled: isDownloadingExcel }"
        @click="downloadExcel"
      >
        <template #content>
          <span
            v-if="isDownloadingExcel"
            class="position-absolute top-50 start-50 translate-middle d-flex"
          >
            <BSpinner small />
          </span>
          <span :class="{ invisible: isDownloadingExcel }">{{ t('global.descargar_excel') }}</span>
        </template>
      </CButton>
      <DataTable
        :loading="isLoadingAudits"
        :fields="fieldsTable"
        :items="auditsData"
        @update:model-value-page="onChangePage"
        :totalRows="paginationData?.count"
        :perPage="20"
        :currentPage="paginationData?.current_page"
      >
      </DataTable>
    </template>
  </Layout>
</template>

<style scoped>
.button__form.disabled {
  opacity: 0.4;
}
</style>
